import React from "react";

import { Toggle, Tooltip, TooltipContent, TooltipTrigger, icons } from "../../../components";
import { getShortcutKeys } from "../../../utils/plateform";

function HistoryActionButton(props) {
	const {
		icon = undefined,
		// title = undefined,
		tooltip = undefined,
		// disabled = false,
		customClass = "",
		// color = undefined,
		// loading = false,
		// shortcutKeys = undefined,
		tooltipOptions = {},
		action = undefined,
		isActive = undefined,
		children
	} = props;

	const Icon = icons[icon];

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Toggle
					size="sm"
					className={`richtext-w-[32px] richtext-h-[32px] ${customClass}`}
					disabled={isActive?.()}
					onClick={action}
					// data-state={isActive?.() ? 'on' : 'off'}
				>
					{Icon && <Icon className="richtext-w-4 richtext-h-4" />}
					{children && <>{children}</>}
				</Toggle>
			</TooltipTrigger>
			{tooltip && (
				<TooltipContent {...tooltipOptions}>
					<div className="richtext-flex richtext-flex-col richtext-items-center richtext-text-center richtext-max-w-24">
						<div>{tooltip}</div>
						{!!props?.shortcutKeys?.length && (
							<span>{getShortcutKeys(props?.shortcutKeys)}</span>
						)}
					</div>
				</TooltipContent>
			)}
		</Tooltip>
	);
}

export default HistoryActionButton;
